<section class="mb-7">
  <div class="w-fit">
    <h2 class="text-47 mb-5 flex flex-wrap justify-center font-bold gap-x-2">
      <span>{{
        "frequently-asked-questions_subtitle_using_the_app" | translate
      }}</span>
    </h2>
  </div>
  <div class="bg-[#F4F4F4] dark:bg-[#0F0F0F] w-full rounded mt-4 lg:mt-7 mb-5">
    <mat-accordion multi>
      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(0)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div
              class="text-ayr-black dark:text-white flex items-center gap-2 teste"
            >
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[0].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[0].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_how_do_I_get_started" | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{
              "frequently-asked-questions_how_do_I_get_started_1" | translate
            }}
          </p>
          <ul class="list">
            <li>
              <span class="pt-4 !text-ayr-black dark:!text-white">
                {{
                  "frequently-asked-questions_how_do_I_get_started_2"
                    | translate
                }}
              </span>
            </li>
            <li>
              <span class="pt-4 !text-ayr-black dark:!text-white">
                {{
                  "frequently-asked-questions_how_do_I_get_started_3"
                    | translate
                }}
              </span>
            </li>
            <li>
              <span class="pt-4 !text-ayr-black dark:!text-white">
                {{
                  "frequently-asked-questions_how_do_I_get_started_4"
                    | translate
                }}
              </span>
            </li>
          </ul>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(1)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div class="text-ayr-black dark:text-white flex items-center gap-2">
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[1].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[1].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_how_do_I_start_a_new_activity"
                  | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{
              "frequently-asked-questions_how_do_I_start_a_new_activity_1"
                | translate
            }}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(2)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div class="text-ayr-black dark:text-white flex items-center gap-2">
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[2].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[2].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_what_sustainable_activities"
                  | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{
              "frequently-asked-questions_what_sustainable_activities_1"
                | translate
            }}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(3)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div class="text-ayr-black dark:text-white flex items-center gap-2">
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[3].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[3].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_how_can_I_see_my_activity"
                  | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{
              "frequently-asked-questions_how_can_I_see_my_activity_1"
                | translate
            }}
          </p>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</section>
